import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { AccountRoutingModule } from './account.routing-module';
import { LogoutCallBackComponent } from './logout/logout-callback.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { AuthService } from '@bya/auth/services/authentication.service';

@NgModule({
    declarations: [LoginComponent,  AuthCallbackComponent, LogoutCallBackComponent],
  providers: [AuthService],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatIconModule,
    AccountRoutingModule
  ]
})
export class AccountModule { }
